<template>
    <tr>
        <td class="invoice_id">
            <div @click="openModal"> #{{ invoice.id }}</div>
            <proforma-invoice-modal :car="invoice.car" v-if="isActive"></proforma-invoice-modal>
           </td>
        <td class="issued_date">{{ invoice.issued_date }}</td>
        <td class="chassis">{{ invoice.car.model_type_en }}</td>
        <td class="due_amount">{{ getCurrency }}{{ getDueAmount() | formatNumber }}</td>
        <td class="used_amount">
            <div class="field paid-amount-field">
                <div class="used_amount_tooltip">The amount entered here is more than the amount paid by the customer.</div>
                <p class="control used_amount-field is-fullwidth">
                    <input class="input" type="text" v-model="used_amount">
                </p>
            </div>
        </td>
        <td class="deposit" v-if="action == 'add'">
            <div class="field select is-fullwidth select-deposit">
                <div class="control">
                    <select v-model="deposit">
                        <option selected :value="null" disabled>Deposit</option>
                        <option value="100%">Pay in full</option>
                        <option value="50%-50%">50%</option>
                        <option value="30%-70%">30%</option>
                        <option value="custom">Custom</option>
                        <option value="remaining">Remaining</option>
                    </select>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>

    import ProformaInvoiceColumn from "../Cars/Columns/ProformaInvoiceColumn";
    import ProformaInvoiceModal from "../Cars/Columns/ProformaInvoice/ProformaInvoiceModal";
    export default {
        props: ['invoice', 'transactionTotals', 'action', 'amount', 'invoiceDeposit', 'invoiceAmountUsed'],
        components: {ProformaInvoiceModal, ProformaInvoiceColumn},
        data() {
            return {
                //used_amount: this.action == 'add' ? this.invoiceAmountUsed : this.invoiceAmountUsed,
                //deposit: this.action == 'add' ? this.invoiceDeposit : this.invoiceDeposit,
            }
        },
        methods: {
            getDueAmount() {
                if (this.invoice.currency == 2 && this.transactionTotals.currency != 2) {
                    return Math.round((this.invoice.balance_due - this.invoice.paid_amount) * this.invoice.rate)
                } else if (this.invoice.currency == 1 && this.transactionTotals.currency != 1) {
                    return Math.round((this.invoice.balance_due - this.invoice.paid_amount) / this.invoice.rate)
                } else {
                    return this.invoice.balance_due - this.invoice.paid_amount
                }
            },
            openModal() {
                this.$store.dispatch('changeProformaInvoiceModalStatus', { status: true, carId: this.invoice.car.id })
                this.$store.dispatch('fetchProformaInvoice', this.invoice.car.id)
            }
        },
        computed: {
            deposit: {
                get() {
                    return this.action == 'add' ? this.invoiceDeposit : this.invoiceDeposit
                },
                set(value) {
                    let deposit = value;
                    let used_amount = 0;
                    let balance = Number(this.invoice.balance_due);
                    let paid_amount = Number(this.invoice.paid_amount);
                    if (deposit == '100%') {
                        used_amount = balance - paid_amount
                       /* if (this.invoice.currency == 2 && this.transactionTotals.currency != 2) {
                            return Math.round((balance - paid_amount) * this.invoice.rate)
                        } else if (this.invoice.currency == 1 && this.transactionTotals.currency != 1) {
                            return Math.round((balance - paid_amount) / this.invoice.rate)
                        } else {
                            used_amount = balance - paid_amount
                        }*/
                    } else if (deposit == '50%-50%') {
                        /*if (this.invoice.currency == 1 || this.invoice.currency == null) {
                            used_amount = Math.round((balance - paid_amount) * 50 / 100)
                        } else {
                            used_amount = Math.round((balance - paid_amount) * (50 / 100) * this.invoice.rate);
                        }*/

                        used_amount = (balance - paid_amount) * 50 / 100
                    } else if (deposit == '30%-70%') {
                        /*if (this.invoice.currency == 1 || this.invoice.currency == null) {
                            used_amount = Math.round((balance - paid_amount) * 30 / 100)
                        } else {
                            used_amount = Math.round((balance - paid_amount) * (30 / 100) * this.invoice.rate);
                        }*/
                        used_amount = (balance - paid_amount) * 30 / 100
                    } else if (deposit == 'remaining') {
                        used_amount = this.amount - this.getAmountUsed + this.invoice.amount_used;
                    }

                    this.invoice.amount_used = used_amount;
                    this.invoice.deposit = deposit;
                    this.$store.commit('updateUnpaidAllInvoices', this.invoice)
                    this.$store.commit('setInvoiceAmountUsed', {'invoice_id': this.invoice.id, 'amount_used': used_amount, 'deposit': deposit})
                }
            },
            used_amount: {
                get() {
                    return this.action == 'add' ? this.invoiceAmountUsed : this.invoiceAmountUsed
                },
                set(value) {
                    this.invoice.amount_used = value;
                    this.$store.commit('updateUnpaidAllInvoices', this.invoice)
                    this.$store.commit('setInvoiceAmountUsed', {'invoice_id': this.invoice.id, 'amount_used': value, 'deposit': this.deposit})
                }
            },
            getCurrency : function () {
                return this.transactionTotals.currency == 2 ? '$' : '¥'
            },
            isActive() {
                return this.$store.getters.getProformaInvoiceModalStatus(this.invoice.car.id)
            },
            getAmountUsed: function () {
                let invoiceAmountUsed = this.$store.getters.getInvoiceAmountUsed
                let used_amount = 0;
                invoiceAmountUsed.forEach((invObj) => {
                    used_amount += Number(invObj.amount_used)
                })

                return used_amount
            },
        }
    }
</script>

<style scoped>
    td {
        font-size: 12px;
    }

    .picture-td {
        width: 65px;
    }

    .link {
        cursor: pointer;
    }

    .image {
        cursor: pointer;
    }
    .used_amount-field {
        max-width: 110px;
    }
    .used_amount_tooltip{
        display: none;
    }
    .error-field .used_amount_tooltip {
        display: block;
        position: absolute;
        width: 169px;
        right: 100%;
        top: 0;
        background-color: #fcf9dc;
        border: 1px solid #ebcc6f;
        border-radius: 3px;
        color: #000;
        padding: 5px 10px;
    }

    .field.paid-amount-field {
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/Banking/UnpaidInvoiceTableRow.vue